import React from 'react';
import {
  CRMContactDetails,
  CRMContactList,
  PlanningScheduler,
  PlanningTaskList,
  PlanningTaskDetails,
  AnalyticsDashboard,
  AnalyticsSalesAnalysis,
  AnalyticsGeography,
  SignInPage,
  RegisterPage,
  ResetPasswordPage,
  UserProfile,
  OverviewPage
} from './pages';
import { Navigate } from 'react-router-dom';
import { AnalyticsCatalogPage, PlanningCatalogPage } from './pages/overview/overview';

export const pageRoutes = [
  { path: '/analytics', title: 'Báo cáo thống kê', element: AnalyticsCatalogPage },
  { path: '/planning', title: 'Kế hoạch', element: PlanningCatalogPage },
  {
    path: '/overview',
    title: 'Tổng quan',
    element: OverviewPage,
  },
  {
    path: '/crm-contact-details',
    title: 'Contact Details',
    element: CRMContactDetails,
  },
  {
    path: '/crm-contact-list',
    title: 'Contact List',
    element: CRMContactList,
  },
  {
    path: '/planning-task-list',
    title: 'Danh sách công việc',
    element: PlanningTaskList,
  },
  {
    path: '/planning-task-details',
    title: 'Chi tiết công việc',
    element: PlanningTaskDetails,
  },
  {
    path: '/planning-scheduler',
    title: 'Lịch công việc',
    element: PlanningScheduler,
  },
  {
    path: '/analytics-dashboard',
    title: 'Ngân sách sửa chữa',
    element: AnalyticsDashboard,
  },
  {
    path: '/analytics-sales-analysis',
    title: 'Sales Analysis',
    element: AnalyticsSalesAnalysis,
  },
  {
    path: '/analytics-geography',
    title: 'Geography',
    element: AnalyticsGeography,
  },
  {
    path: '/sign-in-form',
    title: 'Sign In Form',
    element: SignInPage,
  },
  {
    path: '/register-form',
    title: 'Register Form',
    element: RegisterPage,
  },
  {
    path: '/reset-password-form',
    title: 'Reset Password Form',
    element: ResetPasswordPage,
  },
  {
    path: '/user-profile',
    title: 'User Profile',
    element: UserProfile,
  },
];

const redirects = [
  { from: '/analytics-sales-report', to: '/analytics-sales-analysis' },
  { from: '/sign-up-form', to: '/register-form' },
];

export const redirectRoutes = redirects.map(({ from, to }) => ({
  path: from,
  element: <Navigate to={to} replace />,
}));

export const appRoutes = [
  ...pageRoutes.map((route) => {
    const Component = route.element;
    return {
      ...route,
      element: <Component />,
    };
  }),
  ...redirectRoutes,
];
